export default function authHeader() {
  const user = JSON.parse(
    localStorage.getItem(import.meta.env.VITE_APP_SESSION_TOKEN) || "{}"
  );

  if (user && user.token) {
    return { Authorization: "Bearer " + user.token };
  } else {
    return {};
  }
}
